@if (items().length) {
  <nav class="breadcrumb" aria-label="Breadcrumb navigation">
    <ul>
      @for (item of items(); track item.label; let last = $last) {
        <li>
          @if (item.routerLink && !last) {
            <a [routerLink]="item.routerLink" [queryParams]="item.queryParams">{{ item.label }}</a>
          } @else {
            <span [attr.aria-current]="last ? 'page' : null">{{ item.label }}</span>
          }
          @if (!last) {
            <span class="separator" aria-hidden="true">&gt;</span>
          }
        </li>
      }
    </ul>
  </nav>
}
